export const ROUTES = {
    HOME: '/',
    DASHBOARD: '/',
    APPLY_LOANS: '/applyLoans',
    LOAN_REQUESTS: '/loanRequest',
    MY_LOANS: '/myloans',
    LEADINGS: '/lendings',
    PROFILE_UPDATE: '/profileUpdate',
}

export const API_ROUTES = {
    APPLY_LOAN: '/apply-loan',
    SIGN_UP: '/signup',
    SIGN_IN: '/login',
    LENDING_LOANS: '/lending-loans',
    LOAN_REQUESTS: '/loan-requests',
    ACCEPT_LOAN: '/accept-loan',
    REJECT_LOAN: '/reject-loan',
    MODIFY_LOAN: '/modify-loan',
    PROFILE_UPLOAD: '/profile-screen',
    MAX_ELIGIBLE_LOAN: '/maxEligibleLoan',
}
